import PortalAppService from "../../../application/platform/portal-app-service";
import { IListNewsRequest } from "../../../model/base/request/list-news-request";
import { useNewsDispatch } from "./news-context";
import { ACTION_TYPES } from "./news-reducer";

export const useNewsController = () => {
    const dispatch = useNewsDispatch();

    const loadData = async (params: IListNewsRequest) => {
        try {
            const newsData = await PortalAppService.listNews(params);
            dispatch({ type: ACTION_TYPES.SET_NEWS, payload: newsData });
        } catch (error) {
            console.error('Error loading news data:', error);
        }
    };

    const loadCategories = async () => {
        try {
            const categories = await PortalAppService.listNewsCategories();
            dispatch({ type: ACTION_TYPES.SET_CATEGORIES, payload: categories });
        } catch (error) {
            console.error('Error loading news categories:', error);
        }
    };

    return { loadData, loadCategories };
};
